var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqFeatureGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_889_76363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.50003H13.5V13.5H7.5V7.50003ZM22.5 22.5H28.5V28.5H22.5V22.5ZM7.5 22.5H13.5V28.5H7.5V22.5ZM24.99 6.78003L20.745 11.01L24.99 15.255L29.235 11.01L24.99 6.78003Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.99 2.53491L16.5 11.0099L24.99 19.4999L33.48 11.0099L24.99 2.53491ZM20.745 11.0099L24.99 6.76491L29.235 11.0099L24.99 15.2549L20.745 11.0099ZM4.5 4.49991V16.4999H16.5V4.49991H4.5ZM13.5 13.4999H7.5V7.49991H13.5V13.4999ZM4.5 31.4999H16.5V19.4999H4.5V31.4999ZM7.5 22.4999H13.5V28.4999H7.5V22.4999ZM19.5 19.4999V31.4999H31.5V19.4999H19.5ZM28.5 28.4999H22.5V22.4999H28.5V28.4999Z",
    fill: "#A7B2AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_889_76363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqFeatureGrey);
export default __webpack_public_path__ + "static/media/faq-feature-grey.a0705ac557f6f143c25b1b1e0672a9b6.svg";
export { ForwardRef as ReactComponent };